import { render } from "./TemplateMfittBookingSalesEndError.vue?vue&type=template&id=52538ada&scoped=true"
import script from "./TemplateMfittBookingSalesEndError.vue?vue&type=script&lang=js"
export * from "./TemplateMfittBookingSalesEndError.vue?vue&type=script&lang=js"

import "./TemplateMfittBookingSalesEndError.vue?vue&type=style&index=0&id=52538ada&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-52538ada"

export default script